import React, { useEffect, useState } from 'react'
import '../style/blog.css';
import { useCookies } from 'react-cookie'
import { getBookmarkedBlogs, getMyBlogs } from '../services/UserService'
import { useNavigate } from 'react-router-dom'
import { CircularProgress, Divider, Typography } from '@mui/material'
import 'react-toastify/dist/ReactToastify.css';
import BlogCarousel from './BlogCarousel';
import EmptyComponent from './messages/EmptyComponent';
import { ToastContainer, toast } from 'react-toastify';
import { deleteBlog } from '../services/BlogService';
  
  
export default function Dashboard(){

    const [myBlogs, setMyBlogs] = useState([])
    const [bookmarkedBlogs, setBookmarkedBlogs] = useState([])
    const [cookies, setCookies, removeCookies] = useCookies()
    const [isBookmarksLoading, setIsBookmarksLoading] = useState(true)
    const [isMyBlogsLoading, setIsMyBlogsLoading] = useState(true)
    const navigate = useNavigate()

    const createTokenHeader = () =>{
        if(!cookies['accessToken']){
            navigate('/login')
            return
        }
        const token = cookies['accessToken'].access_token
        const _headers = {"Authorization" : `Bearer ${token}`}
        return _headers
    }

    useEffect(()=>{
      setIsBookmarksLoading(true)
      setIsMyBlogsLoading(true)
      const _headers = createTokenHeader()

      getBookmarkedBlogs(_headers)
      .then((res)=>{
        console.log(res)
        setBookmarkedBlogs(res.data)
        setIsBookmarksLoading(false)
      })
      .catch(err=>{
        console.log(err)
        setIsBookmarksLoading(false)
    })

      getMyBlogs(_headers)
      .then((res)=>{
        console.log(res)
        setMyBlogs(res.data)
        setIsMyBlogsLoading(false)
      })
      .catch(err=>{
        console.log(err)
        setIsMyBlogsLoading(false)
      })

    }, [])

    const handleDelete = (blogId) =>{
        if(window.confirm("Do you want to delete the blog?")){
            const _headers = createTokenHeader()
            deleteBlog(blogId, _headers)
            .then((res)=>{
                if(res.status == 200){
                    const updatedMyBlogs = myBlogs.filter((blog)=> blog.blogId != blogId)
                    setMyBlogs(updatedMyBlogs)
                    toast.error("Blog Deleted")
                    console.log(res.data)
                }
            })
            .catch((err)=>{
                console.log(err)
            })
        }
    }

    const handleShareToast = (message) =>{
        toast.info(message)
    }

    return(
        <div style={{marginTop: '2em'}}>
        <ToastContainer
          position="top-right"
          autoClose={2000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable={false}
          pauseOnHover={false}
          theme="light"
          />
            {(isBookmarksLoading && isMyBlogsLoading) && <CircularProgress />}
            <div className='bookmarks'>
                <div className='dashboard-heading'>
                    <Typography sx={{variant:"body1", color:"text.primary", fontSize:45, }} >
                    Bookmarks
                    </Typography>
                </div>
            {
                bookmarkedBlogs != 0 ? 
                !isBookmarksLoading &&
                <BlogCarousel blogs={bookmarkedBlogs} authorDetailsNeeded={true} handleShareToast={handleShareToast}/>
                : 
                    !isBookmarksLoading &&
                    <EmptyComponent message="No Bookmarks to display"/>
                }
            </div>
            <Divider sx={{borderTop: "1.5px solid #e1e1e1d1" }}/>
            <div className='myBlogs'>
                <div className='dashboard-heading'>
                    <Typography sx={{variant:"body1", color:"text.primary", fontSize:45, }} >
                    My Blogs
                    </Typography>
                </div>
            {
                myBlogs != 0 ? 
                !isMyBlogsLoading &&
                <BlogCarousel
                 blogs={myBlogs} 
                 authorDetailsNeeded={false} 
                 handleShareToast={handleShareToast} 
                 deleteButtonNeeded={true}
                 handleDelete={handleDelete}
                 />
                : 
                    !isMyBlogsLoading &&
                    <EmptyComponent message="You haven't created any blogs yet"/>
                }
            </div>
        </div>
    )
}